export default "__VITE_ASSET__BjIWpi2I__"